import { formatDistanceToNow, parseISO } from "date-fns";
import { Focusable } from "react-aria-components";
import { Tooltip } from "@/components/base/tooltip/tooltip";

type Props = {
  date: string | null;
  prefix?: string;
  className?: string;
};

const absoluteDateFormatter = new Intl.DateTimeFormat("en-US", {
  year: "numeric",
  month: "short",
  day: "numeric",
});

/**
 * Renders a relative date (e.g., "~2 days ago") with the absolute date shown
 * below and a tooltip exposing the full absolute date on hover.
 */
export const RelativeDateCell = ({ date, prefix = "~", className }: Props) => {
  if (!date) {
    return <span className="text-sm text-tertiary">-</span>;
  }

  const parsedDate = parseISO(date);
  const relativeTime = formatDistanceToNow(parsedDate, { addSuffix: true });
  const formattedRelativeTime = relativeTime.replace("about ", "");
  const absoluteDate = absoluteDateFormatter.format(parsedDate);

  return (
    <Tooltip title={absoluteDate}>
      <Focusable>
        <div className="flex flex-col w-fit text-center outline-hidden">
          <span className={className ?? "text-sm text-primary"}>
            {prefix}
            {formattedRelativeTime}
          </span>
          <span className={className ?? "text-xs text-tertiary"}>{absoluteDate}</span>
        </div>
      </Focusable>
    </Tooltip>
  );
};
